import { stacks } from "@dropbox/api-v2-client";
import { UIIcon } from "@dropbox/dig-icons";
import { CheckmarkLine, FailLine } from "@dropbox/dig-icons/assets";
import { PAP_Click_DashStackUnsubscribe } from "@mirage/analytics/events/types/click_dash_stack_unsubscribe";
import { updateSubscription } from "@mirage/service-stacks";
import { showSnackbar } from "@mirage/shared/snackbar";
import { useReportStackPapEvent } from "@mirage/stacks/hooks/useReportStackPapEvent";
import i18n from "@mirage/translations";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export function useStackUnsubscribeUrl(stack: stacks.Stack | null | undefined) {
  const reportStackPapEvent = useReportStackPapEvent();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    async function handleUnsubscribe() {
      // If we're missing a Stack or the Stack is missing a sharing_id, we can't update the subscription
      if (!stack || !stack.namespace_id || !stack.sharing_id) {
        return;
      }

      try {
        await updateSubscription(
          stack.namespace_id,
          stack.sharing_id,
          false, // Disable notifications for this stack
        );

        showSnackbar({
          accessory: <UIIcon src={CheckmarkLine} />,
          title: i18n.t("disable_stack_notifications_success"),
        });

        reportStackPapEvent(
          // TODO (DASHWEB-5681): Work with DS to customize what gets recorded here
          PAP_Click_DashStackUnsubscribe(),
        );
      } catch (error) {
        showSnackbar({
          accessory: <UIIcon src={FailLine} />,
          title: i18n.t("disable_stack_notifications_failure"),
        });
      } finally {
        // Remove the unsubscribe query param from the URL
        searchParams.delete("unsubscribe");
        setSearchParams(searchParams);
      }
    }

    // If the current url contains the unsubscribe query param, we need to disable notifications for the stack
    if (searchParams.get("unsubscribe")) {
      void handleUnsubscribe();
    }
  }, [reportStackPapEvent, searchParams, stack]);
}
